import info from "./info";

export default {
    info,
}
